import React, { useEffect, useState } from 'react';
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalElement: number;
  onPageChange: (page: number) => void;
  onNext: () => void;
  onPrevious: () => void;
}
const Pagination: React.FC<PaginationProps> = ({
  totalPages,
  currentPage,
  totalElement,
  onPageChange,
  onNext,
  onPrevious,
}) => {
  const [visiblePages, setVisiblePages] = useState<number[]>([]);

  useEffect(() => {
    const pages = [];
    const totalVisiblePages = 10;
    const half = Math.floor(totalVisiblePages / 2);

    let startPage = currentPage - half > 0 ? currentPage - half : 1;
    let endPage = startPage + totalVisiblePages - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage =
        endPage - totalVisiblePages + 1 > 0
          ? endPage - totalVisiblePages + 1
          : 1;
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    setVisiblePages(pages);
  }, [totalPages, currentPage]);

  const goToPage = (page: number) => {
    // setCurrentPage(page - 1);
  };
  const pagesToShow = 10;
  const startPage = Math.max(
    1,
    Math.floor(currentPage / pagesToShow) * pagesToShow + 1
  );
  const endPage = Math.min(totalPages, startPage + pagesToShow - 1);
  return (
    <div className='flex items-center justify-center  border-b-[3px] border-gray-200 '>
      <div>
        <ul
          className='flex justify-center items-center gap-x-[10px] z-30 p-[10px]'
          role='navigation'
          aria-label='Pagination'
        >
          <button
            onClick={onPrevious}
            disabled={currentPage === 0}
            className='text-gray-600 hover:text-gray-900 mr-6 flex gap-2 items-center font-semibold text-sm'
          >
            <img src='/images/Back_Arrow_left.png' /> Previous
          </button>
          {/* <li
            className={`prev-btn flex items-center justify-center w-[30px] rounded-[6px] h-[30px] border-[1px] border-solid border-[#E4E4EB] ${
              currentPage === 0 ? 'bg-[#cccccc] pointer-events-none' : ' cursor-pointer'
            }`}
            onClick={onPrevious}
          >
            <img className ="w-4 h-4" src="/images/left.png" alt=''/>
          </li> */}
          {Array.from(
            { length: endPage - startPage + 1 },
            (_, index) => startPage + index
          ).map((page) => (
            <li
              key={page}
              className={`flex items-center justify-center w-[30px] text-sm   ${
                currentPage + 1 === page
                  ? 'text-[#B00A2B] border-b-[3px] border-[#B00A2B] font-bold'
                  : 'border-[#E4E4EB] font-normal'
              }  cursor-pointer`}
              onClick={() => onPageChange(page - 1)}
            >
              {page}
            </li>
          ))}
          {/* <button onClick={() => goToPage(totalPages)} className="mx-1 px-3 py-1 text-gray-600 hover:text-gray-900">
            {totalPages}
          </button> */}
          {/* <li
            className={`flex items-center justify-center w-[30px] rounded-[6px] h-[30px] border-[1px] border-solid border-[#E4E4EB] ${
              currentPage === totalPages - 1 ? 'bg-[#cccccc] pointer-events-none' : ' cursor-pointer'
            }`}
            onClick={onNext}
          >
             <img className ="w-4 h-4 rotate-180" src="/images/left.png" alt=''/>
          </li> */}
        </ul>
        {/* {visiblePages.map((page) => (
        <button
          key={page}
          onClick={() => goToPage(page)}
          className={`mx-1 px-3 py-1 ${currentPage === page - 1 ? 'text-red-600' : 'text-gray-600'} hover:text-gray-900`}
        >
          {page}
        </button>
      ))} */}
      </div>

      <button
        onClick={onNext}
        disabled={currentPage === totalPages - 1}
        className='text-gray-600 hover:text-gray-900 ml-6 flex gap-2 items-center font-semibold text-sm'
      >
        Next <img src='/images/Arrow_right.png' />
      </button>
    </div>
  );
};

export default Pagination;
